var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GlobalNotification'),(!_vm.pagePending && _vm.accessToRoutedView)?_c('Layout',[_c('RouterView')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }